import { useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useSetAtom } from 'jotai';

import { useFilterToUrlParser } from 'src/common/components/Filters/hooks/useFilterToUrlParser';

import { esimProductsUrlParamsAtom } from 'src/atoms/filters/esim-products';

export const ESimFiltersURLParser = ({ children }: { children: React.ReactElement }) => {
  const [searchParams] = useSearchParams();
  const setFilters = useSetAtom(esimProductsUrlParamsAtom);
  const isMounted = useRef(false);

  useFilterToUrlParser(
    {
      urlSearchParamsAtom: esimProductsUrlParamsAtom,
    },
    isMounted.current,
  );

  if (!isMounted.current) {
    setFilters(searchParams);
    isMounted.current = true;
  }

  return <>{children}</>;
};
